import { Injectable } from '@angular/core';
import { BffCommunicationService } from '../../core/services/bff-communication.service';
import { AppConfigService } from '../../app-config.service';
import { Observable } from 'rxjs';
import { PhotoUpload } from '../modeles/photo-upload.modele';

@Injectable({
  providedIn: 'root'
})
export class UploadApiService {
  constructor(
    private readonly _bffCommunicationService: BffCommunicationService,
    private readonly _appConfigService: AppConfigService
  ) {}

  private getApiUrl() {
    const idProjet = this._appConfigService.idProjet;
    return `/api/v2/projets/${idProjet}/images`;
  }

  upload(blob: Blob, originalName: string): Observable<PhotoUpload> {
    const formData = new FormData();
    formData.append('file', blob, originalName);

    return this._bffCommunicationService.postForm(`${this.getApiUrl()}`, formData) as Observable<PhotoUpload>;
  }
}
